import { render, staticRenderFns } from "./SalesEdit.vue?vue&type=template&id=36ce47ef&scoped=true"
import script from "./SalesEdit.vue?vue&type=script&lang=js"
export * from "./SalesEdit.vue?vue&type=script&lang=js"
import style0 from "./SalesEdit.vue?vue&type=style&index=0&id=36ce47ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce47ef",
  null
  
)

export default component.exports